import { render, staticRenderFns } from "./MemberWritePortfolioLayout.vue?vue&type=template&id=d1c90478&scoped=true"
import script from "./MemberWritePortfolioLayout.vue?vue&type=script&lang=js"
export * from "./MemberWritePortfolioLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c90478",
  null
  
)

export default component.exports